"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var planimetry_1 = require("../../planimetry");
var shapes_1 = require("../../shapes");
var R_1 = require("../../R");
var ControlPoint = /** @class */ (function (_super) {
    __extends(ControlPoint, _super);
    function ControlPoint(rectPos, filled) {
        if (rectPos === void 0) { rectPos = [0, 0, 0, 0]; }
        if (filled === void 0) { filled = true; }
        var _this = _super.call(this) || this;
        _this.rectPos = rectPos;
        _this.filled = filled;
        _this.render = function (ctx) {
            R_1.putRect(_this.rectPos, _this.filled)(ctx);
        };
        _this.pathIndex = 0;
        _this.syncValue();
        return _this;
    }
    ControlPoint.prototype.syncValue = function () {
        var _a = __read(this.rectPos, 4), x = _a[0], y = _a[1], w = _a[2], h = _a[3];
        this.setValue([
            [x, y],
            [x + w, y],
            [x, y + h],
            [x + w, y + h],
        ]);
    };
    ControlPoint.prototype.inRegion = function (p) {
        return planimetry_1.isInPolygon(this.valueOf(), p);
    };
    ControlPoint.prototype.moveUp = function (n) {
        var _a = __read(this.rectPos, 4), x = _a[0], y = _a[1], w = _a[2], h = _a[3];
        this.rectPos = [x, y - n, w, h];
        this.syncValue();
    };
    ControlPoint.prototype.moveDown = function (n) {
        var _a = __read(this.rectPos, 4), x = _a[0], y = _a[1], w = _a[2], h = _a[3];
        this.rectPos = [x, y + n, w, h];
        this.syncValue();
    };
    ControlPoint.prototype.moveLeft = function (n) {
        var _a = __read(this.rectPos, 4), x = _a[0], y = _a[1], w = _a[2], h = _a[3];
        this.rectPos = [x - n, y, w, h];
        this.syncValue();
    };
    ControlPoint.prototype.moveRight = function (n) {
        var _a = __read(this.rectPos, 4), x = _a[0], y = _a[1], w = _a[2], h = _a[3];
        this.rectPos = [x + n, y - n, w, h];
        this.syncValue();
    };
    ControlPoint.genControlPoint = function (value) {
        return value.map(function (p, i) {
            var _a = __read(p, 2), x = _a[0], y = _a[1];
            var rect = [x - 2, y - 2, 4, 4];
            var cp = new ControlPoint(rect);
            cp.pathIndex = i;
            return cp;
        });
    };
    ControlPoint.createPoint = function (x, y, i) {
        var rect = [x - 2, y - 2, 4, 4];
        var cp = new ControlPoint(rect);
        cp.pathIndex = i;
        return cp;
    };
    ControlPoint.prototype.onMouseEnter = function (e) {
        e.viewport.engine.ctx.canvas.style.cursor = 'move';
        return false;
    };
    ControlPoint.prototype.setXY = function (x, y) {
        var _a = __read(this.rectPos, 4), w = _a[2], h = _a[3];
        this.rectPos = [x, y, w, h];
        this.syncValue();
    };
    ControlPoint.prototype.onMouseLeave = function (e) {
        e.viewport.engine.ctx.canvas.style.cursor = 'default';
        return false;
    };
    return ControlPoint;
}(shapes_1.Shape));
exports.ControlPoint = ControlPoint;
//# sourceMappingURL=ControlPoint.js.map